import {useContext} from "react";
import {INotificationContext, NotificationContextState} from "../context/NotificationContext";

export const useNotification = () => useContext<NotificationContextState>(INotificationContext)